import { createSelector } from 'reselect';
import { createImmutableSelector } from 'util/reselectUtils';

// Type of the rbac auth item
const TYPE_GROUP = 3;

// Selector returns all rbac permissions
export const getPermissions = (state) =>
  state.getIn(['entities', 'rbac', 'items']).sort((a, b) => {
    const aName = a.get('name');
    const bName = b.get('name');
    if (aName > bName) {
      return -1;
    } else if (bName > aName) {
      return 1;
    } else {
      return 0;
    }
  });

const getUserPermissionsFromState = (state) => state.getIn(['entities', 'rbac', 'userPermissions']);

// Selector returns all current user permissions
export const getUserPermissions = createImmutableSelector(
  [getUserPermissionsFromState, (_, props) => props?.model],
  (userPermissions, model) => {
    if (!model) {
      return userPermissions;
    }

    return userPermissions.filter((permission) => permission.get('model') === model);
  },
);

// Selector returns all rbac auth items with type equal to group, and sorted by permission name DESC
export const getRbacGroupPermissions = createSelector([getPermissions], (permissions) =>
  permissions.filter((item) => item.get('type') === TYPE_GROUP),
);
